const EVENTS = {
	Player: [
		'Loaded',
		'Ad Playing',
		'Ad Finished',
		'Ad Skipped',
		'Video Started',
		'15 Seconds Playtime',
	],
};

const DIMENSIONS = [
	'eventId',
	'eventName',
];

export default class Analytics {
	constructor() {
		// Note: we don't use Google Analylitics anymore. Could replace this with Mixpanel, but need to keep events amount low.
		this.disabled = true;
	}

	trackEvent(component, eventName, properties = {}, _value = 1) {
		if (this.disabled) {
			return;
		}

		if (!Object.keys(EVENTS).includes(component)) {
			console.error('Analytics: Invalid component: ' + component);
			return;
		}

		if (!EVENTS[component].includes(eventName)) {
			console.error('Analytics: Invalid event: ' + component + ': ' + eventName);
			return;
		}

		if (Object.keys(properties).filter(x => !DIMENSIONS.includes(x)).length > 0) {
			console.error('Analytics: Invalid dimensions: ' + Object.keys(properties).filter(x => !DIMENSIONS.includes(x)));
			return;
		}

		return undefined;
		// gtag('event', component + ': ' + eventName, { ...{ value: value }, ...properties });
	}
}
